// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import Plus from "@insite/mobius/Icons/Plus";
import { jettingAppHosesStyles } from "@stoneage/App/Components/JettingAppComponents/JettingAppHoses";
import IconTooltip from "@stoneage/XDL/Icons/IconTooltip";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { createLinkIconStyles } from "@stoneage/XDL/Utilities/SharedStyles/sharedStyles";
import { css } from "styled-components";

jettingAppHosesStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;
    `,
};

jettingAppHosesStyles.addLink = {
    ...createLinkIconStyles(Plus, "default", "left", {
        icon: {
            iconProps: {
                size: 15,
                css: css`
                    margin-right: 8px;
                `,
            },
        },
    }),
};
jettingAppHosesStyles.rowWrapper = {
    css: css`
        display: flex;
        column-gap: 8px;
        align-items: flex-end;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: start;
            row-gap: 2px;
        }
    `,
};

jettingAppHosesStyles.inputsWrapper = {
    css: css`
        display: flex;
        column-gap: 12px;
        align-items: center;
        ${xScreen("lte", "md")} {
            align-items: end;
        }
    `,
};
jettingAppHosesStyles.rowTitle = {
    size: 14,
    lineHeight: "22px",
    weight: "bold",
    css: css`
        margin-bottom: 6px;
        white-space: nowrap;
        display: flex;
        align-items: center;
    `,
};

jettingAppHosesStyles.removeWrapper = {
    css: css`
        width: 13px;
    `,
};

jettingAppHosesStyles.dropDown = {
    wrapper: {
        css: css`
            width: 105px;
            ${xScreen("lte", "md")} {
                width: calc((100% - 37px) / 2);
            }
        `,
    },
    dropDown: {
        labelProps: {
            css: css`
                &&& {
                    font-size: 14px;
                    line-height: 22px;
                    font-weight: bold;
                }
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                &&&& {
                    margin-top: 2px;
                }
            `,
        },
    },
};
jettingAppHosesStyles.textFieldStyles = {
    wrapper: {
        css: css`
            max-width: 149px;
            ${xScreen("lte", "md")} {
                width: calc((100% - 37px) / 2);
                max-width: unset;
            }
        `,
    },
    textField: {
        labelProps: {
            css: css`
                &&&& {
                    line-height: 22px;
                }
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                &&&& {
                    margin-top: 2px;
                }
            `,
        },
    },
    unit: {
        css: css`
            bottom: 0;
            top: unset;
        `,
    },
};
jettingAppHosesStyles.linkWrapper = {
    css: css`
        margin-left: calc(100% - 291px);
        ${xScreen("lte", "md")} {
            margin-left: 0;
        }
    `,
};
jettingAppHosesStyles.removeButton = {
    css: css`
        &&& {
            background: none;
            border: none;
            padding: 0;
            ${IconWrapper}, svg {
                color: ${color("text.main")};
                width: 13px;
            }
            &:hover,
            focus {
                ${IconWrapper}, svg {
                    color: ${color("text.link")};
                }
            }
        }
    `,
};

jettingAppHosesStyles.tooltip = {
    iconProps: {
        src: IconTooltip,
        color: "primary.main",
        size: 14,
        css: css`
            margin-left: 4px;
            &: hover {
                opacity: 0.33;
            }
        `,
    },
    cssOverrides: {
        tooltipClickable: css`
            display: flex;
            &[aria-expanded="true"] {
                ${IconWrapper} {
                    color: ${color("common.black")};
                }
            }
        `,
        tooltipBody: css`
            white-space: normal;
        `,
    },
};

jettingAppHosesStyles.messageStyle = {
    size: 12,
    weight: 600,
    css: css`
        &.error {
            color: ${color("danger.main")};
        }
        &.warning {
            color: ${color("warning.main")};
        }
    `,
};

jettingAppHosesStyles.messageWrapper = {
    css: css`
        display: flex;
        column-gap: 8px;
        align-items: flex-start;

        ${({ bgColor }: any) =>
            bgColor &&
            `background-color: ${bgColor};
            padding: 8px 12px;
            `}
    `,
};

jettingAppHosesStyles.message = {
    size: 14,
    lineHeight: "16px",
    weight: "bold",
};
